// Add your custom JS here.
document.addEventListener('DOMContentLoaded', () => {
    const navbarToggler = document.querySelector('.navbar-toggler');
    const btnClose = document.querySelector('.btn-close');
    const body = document.querySelector('body');

    navbarToggler.addEventListener('click', () => {
        body.classList.add('mmenu-open');
    });

    btnClose.addEventListener('click', () => {
        body.classList.remove('mmenu-open');
    });


    // Get all anchor links
    const anchorLinks = document.querySelectorAll('a[href^="#"]');

// Attach click event listener to each anchor link
    anchorLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            const targetId = link.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                const offset = targetElement.offsetTop - 200; // Adjust the offset as per your requirement
                window.scrollTo({ top: offset, behavior: 'smooth' });
            }
        });
    });

});
